export interface Country {
  code: string; // Country calling code (e.g., "+91")
  countryCode: string; // ISO country code (e.g., "IN")
  name: string;
  flag: string; // Emoji flag
  maxLength: number; // Maximum phone number length (without country code)
  currency: string; // Currency code (e.g., "INR", "USD")
  symbol: string; // Currency symbol (e.g., "₹", "$")
}

export const COUNTRIES: Country[] = [
  // South Asia
  { code: '+91', countryCode: 'IN', name: 'India', flag: '🇮🇳', maxLength: 10, currency: 'INR', symbol: '₹' },
  { code: '+92', countryCode: 'PK', name: 'Pakistan', flag: '🇵🇰', maxLength: 10, currency: 'PKR', symbol: 'Rs' },
  { code: '+880', countryCode: 'BD', name: 'Bangladesh', flag: '🇧🇩', maxLength: 10, currency: 'BDT', symbol: '৳' },
  { code: '+94', countryCode: 'LK', name: 'Sri Lanka', flag: '🇱🇰', maxLength: 9, currency: 'LKR', symbol: 'Rs' },
  { code: '+977', countryCode: 'NP', name: 'Nepal', flag: '🇳🇵', maxLength: 10, currency: 'NPR', symbol: 'Rs' },
  
  // Southeast Asia
  { code: '+65', countryCode: 'SG', name: 'Singapore', flag: '🇸🇬', maxLength: 8, currency: 'SGD', symbol: 'S$' },
  { code: '+60', countryCode: 'MY', name: 'Malaysia', flag: '🇲🇾', maxLength: 10, currency: 'MYR', symbol: 'RM' },
  { code: '+62', countryCode: 'ID', name: 'Indonesia', flag: '🇮🇩', maxLength: 12, currency: 'IDR', symbol: 'Rp' },
  { code: '+66', countryCode: 'TH', name: 'Thailand', flag: '🇹🇭', maxLength: 9, currency: 'THB', symbol: '฿' },
  { code: '+84', countryCode: 'VN', name: 'Vietnam', flag: '🇻🇳', maxLength: 10, currency: 'VND', symbol: '₫' },
  { code: '+63', countryCode: 'PH', name: 'Philippines', flag: '🇵🇭', maxLength: 10, currency: 'PHP', symbol: '₱' },
  
  // Middle East
  { code: '+971', countryCode: 'AE', name: 'UAE', flag: '🇦🇪', maxLength: 9, currency: 'AED', symbol: 'AED' },
  { code: '+966', countryCode: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', maxLength: 9, currency: 'SAR', symbol: 'SAR' },
  { code: '+974', countryCode: 'QA', name: 'Qatar', flag: '🇶🇦', maxLength: 8, currency: 'QAR', symbol: 'QAR' },
  { code: '+965', countryCode: 'KW', name: 'Kuwait', flag: '🇰🇼', maxLength: 8, currency: 'KWD', symbol: 'KWD' },
  { code: '+968', countryCode: 'OM', name: 'Oman', flag: '🇴🇲', maxLength: 8, currency: 'OMR', symbol: 'OMR' },
  { code: '+973', countryCode: 'BH', name: 'Bahrain', flag: '🇧🇭', maxLength: 8, currency: 'BHD', symbol: 'BHD' },
  
  // East Asia
  { code: '+86', countryCode: 'CN', name: 'China', flag: '🇨🇳', maxLength: 11, currency: 'CNY', symbol: '¥' },
  { code: '+81', countryCode: 'JP', name: 'Japan', flag: '🇯🇵', maxLength: 10, currency: 'JPY', symbol: '¥' },
  { code: '+82', countryCode: 'KR', name: 'South Korea', flag: '🇰🇷', maxLength: 10, currency: 'KRW', symbol: '₩' },
  { code: '+852', countryCode: 'HK', name: 'Hong Kong', flag: '🇭🇰', maxLength: 8, currency: 'HKD', symbol: 'HK$' },
  
  // North America
  { code: '+1', countryCode: 'US', name: 'United States', flag: '🇺🇸', maxLength: 10, currency: 'USD', symbol: '$' },
  { code: '+1', countryCode: 'CA', name: 'Canada', flag: '🇨🇦', maxLength: 10, currency: 'CAD', symbol: 'CA$' },
  { code: '+52', countryCode: 'MX', name: 'Mexico', flag: '🇲🇽', maxLength: 10, currency: 'MXN', symbol: 'MX$' },
  
  // Europe
  { code: '+44', countryCode: 'GB', name: 'United Kingdom', flag: '🇬🇧', maxLength: 10, currency: 'GBP', symbol: '£' },
  { code: '+49', countryCode: 'DE', name: 'Germany', flag: '🇩🇪', maxLength: 11, currency: 'EUR', symbol: '€' },
  { code: '+33', countryCode: 'FR', name: 'France', flag: '🇫🇷', maxLength: 9, currency: 'EUR', symbol: '€' },
  { code: '+39', countryCode: 'IT', name: 'Italy', flag: '🇮🇹', maxLength: 10, currency: 'EUR', symbol: '€' },
  { code: '+34', countryCode: 'ES', name: 'Spain', flag: '🇪🇸', maxLength: 9, currency: 'EUR', symbol: '€' },
  { code: '+31', countryCode: 'NL', name: 'Netherlands', flag: '🇳🇱', maxLength: 9, currency: 'EUR', symbol: '€' },
  { code: '+41', countryCode: 'CH', name: 'Switzerland', flag: '🇨🇭', maxLength: 9, currency: 'CHF', symbol: 'CHF' },
  { code: '+46', countryCode: 'SE', name: 'Sweden', flag: '🇸🇪', maxLength: 10, currency: 'SEK', symbol: 'kr' },
  { code: '+47', countryCode: 'NO', name: 'Norway', flag: '🇳🇴', maxLength: 8, currency: 'NOK', symbol: 'kr' },
  { code: '+45', countryCode: 'DK', name: 'Denmark', flag: '🇩🇰', maxLength: 8, currency: 'DKK', symbol: 'kr' },
  
  // Oceania
  { code: '+61', countryCode: 'AU', name: 'Australia', flag: '🇦🇺', maxLength: 9, currency: 'AUD', symbol: 'A$' },
  { code: '+64', countryCode: 'NZ', name: 'New Zealand', flag: '🇳🇿', maxLength: 10, currency: 'NZD', symbol: 'NZ$' },
  
  // Africa
  { code: '+27', countryCode: 'ZA', name: 'South Africa', flag: '🇿🇦', maxLength: 9, currency: 'ZAR', symbol: 'R' },
  { code: '+234', countryCode: 'NG', name: 'Nigeria', flag: '🇳🇬', maxLength: 10, currency: 'NGN', symbol: '₦' },
  { code: '+254', countryCode: 'KE', name: 'Kenya', flag: '🇰🇪', maxLength: 10, currency: 'KES', symbol: 'KSh' },
  { code: '+20', countryCode: 'EG', name: 'Egypt', flag: '🇪🇬', maxLength: 10, currency: 'EGP', symbol: 'E£' },
];

// Default country (India)
export const DEFAULT_COUNTRY = COUNTRIES[0];

// Find country by code
export const findCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(country => country.code === code);
};

// Find country by ISO country code
export const findCountryByISOCode = (isoCode: string): Country | undefined => {
  return COUNTRIES.find(country => country.countryCode === isoCode);
};

// Sort prefixes by length descending so +880 or +971 matches before shorter prefixes
const SORTED_COUNTRIES_BY_CODE = [...COUNTRIES].sort(
  (a, b) => b.code.length - a.code.length
);

/**
 * Returns currency info (code & symbol) deduced from phone number
 */
export const getCurrencyFromPhone = (phone?: string | null): { code: string; symbol: string } => {
  if (!phone) {
    return { code: DEFAULT_COUNTRY.currency, symbol: DEFAULT_COUNTRY.symbol };
  }

  const trimmed = phone.trim();
  const normalized = trimmed.startsWith('+') ? trimmed : `+${trimmed}`;

  for (const country of SORTED_COUNTRIES_BY_CODE) {
    if (normalized.startsWith(country.code)) {
      return { code: country.currency, symbol: country.symbol };
    }
  }

  return { code: DEFAULT_COUNTRY.currency, symbol: DEFAULT_COUNTRY.symbol };
};
